/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Welcome_Skip_NoteInputs */

const en_onboarding_welcome_skip_note = /** @type {(inputs: Onboarding_Welcome_Skip_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can skip any step and come back later.`)
};

const de_onboarding_welcome_skip_note = /** @type {(inputs: Onboarding_Welcome_Skip_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du kannst jeden Schritt überspringen und später zurückkommen.`)
};

const fr_onboarding_welcome_skip_note = /** @type {(inputs: Onboarding_Welcome_Skip_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu peux passer toute étape et revenir plus tard.`)
};

const es_onboarding_welcome_skip_note = /** @type {(inputs: Onboarding_Welcome_Skip_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puede omitir cualquier paso y volver más tarde.`)
};

const it_onboarding_welcome_skip_note = /** @type {(inputs: Onboarding_Welcome_Skip_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puoi saltare qualsiasi passaggio e tornare indietro in seguito.`)
};

const nl_onboarding_welcome_skip_note = /** @type {(inputs: Onboarding_Welcome_Skip_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je kunt elke stap overslaan en later terugkomen.`)
};

const pl_onboarding_welcome_skip_note = /** @type {(inputs: Onboarding_Welcome_Skip_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Możesz pominąć każdy krok i wrócić później.`)
};

const fi_onboarding_welcome_skip_note = /** @type {(inputs: Onboarding_Welcome_Skip_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voit ohittaa minkä tahansa vaiheen ja palata myöhemmin.`)
};

const da_onboarding_welcome_skip_note = /** @type {(inputs: Onboarding_Welcome_Skip_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du kan springe over ethvert trin og komme tilbage senere.`)
};

const sv_onboarding_welcome_skip_note = /** @type {(inputs: Onboarding_Welcome_Skip_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du kan hoppa över vilket steg som helst och komma tillbaka senare.`)
};

/**
* | output |
* | --- |
* | "You can skip any step and come back later." |
*
* @param {Onboarding_Welcome_Skip_NoteInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const onboarding_welcome_skip_note = /** @type {((inputs?: Onboarding_Welcome_Skip_NoteInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Welcome_Skip_NoteInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_onboarding_welcome_skip_note(inputs)
	if (locale === "fr") return fr_onboarding_welcome_skip_note(inputs)
	if (locale === "es") return es_onboarding_welcome_skip_note(inputs)
	if (locale === "it") return it_onboarding_welcome_skip_note(inputs)
	if (locale === "nl") return nl_onboarding_welcome_skip_note(inputs)
	if (locale === "pl") return pl_onboarding_welcome_skip_note(inputs)
	if (locale === "fi") return fi_onboarding_welcome_skip_note(inputs)
	if (locale === "da") return da_onboarding_welcome_skip_note(inputs)
	if (locale === "sv") return sv_onboarding_welcome_skip_note(inputs)
	return en_onboarding_welcome_skip_note(inputs)
});